/*
  Created By Muhammad Hassaan
  Date 10 April 2023
*/
import PropTypes from "prop-types";
import { Dialog, DialogTitle, Paper } from "@mui/material";
import Draggable from "react-draggable";
import classNames from "classnames";
import { defaultLabelColors } from "../../utils/constants";

function PaperComponent(props: any) {
  return <Paper {...props} />;
}

function DraggablePaperComponent(props: any) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export function CustomDialogBox(props: any) {
  const {
    handleClose,
    open,
    maxWidth,
    classes,
    dialog_title,
    draggable,
    dialogBody,
    dialogFooter,
    dialog_style,
    Width,
  } = props;
  return (
    <div>
      <Dialog
        disableScrollLock={false}
        open={open}
        onClose={handleClose}
        fullWidth
        style={dialog_style}
        maxWidth={maxWidth}
        PaperComponent={draggable ? DraggablePaperComponent : PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: "16px", // 👈 Added borderRadius
            width: Width ? Width : "auto",
            background: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <DialogTitle
          style={{
            cursor: draggable ? "move" : "auto",
            fontFamily: "montserrat-Bold",
            fontSize: 20,
            color: defaultLabelColors.main_font,
            borderBottom: "none", // 👈 Removed the line after title
            border: "none",
            padding:"0px 50px"
          }}
        >
          <div
            className={classes?.display_flex_baseline}
            style={{ display: "flex", border: "none" }}
          >
            <span
              style={{
                flex: 1,
                fontFamily: "montserrat-Bold",
                fontSize: 20,
              }}
              className={classNames("Raleway-Extra-Bold")}
            >
              {dialog_title}
            </span>

            <div
              style={{ cursor: "pointer", color: "#6F6F6F", fontSize: 20 }}
              className={classNames("Raleway-Variable")}
              onClick={handleClose}
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_347_53381)">
                  <g clip-path="url(#clip1_347_53381)">
                    <rect
                      width="38"
                      height="38"
                      rx="19"
                      fill="white"
                      fill-opacity="0.7"
                    />
                    <path
                      d="M26 12L12 26"
                      stroke="#78778A"
                      stroke-width="2.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 12L26 26"
                      stroke="#78778A"
                      stroke-width="2.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_347_53381">
                    <rect width="38" height="38" fill="white" />
                  </clipPath>
                  <clipPath id="clip1_347_53381">
                    <rect width="38" height="38" rx="19" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </DialogTitle>
        {dialogBody}
        {dialogFooter}
      </Dialog>
    </div>
  );
}

CustomDialogBox.defaultProps = {
  open: false,
  maxWidth: "md",
  dialog_title: "",
  handleClose: () => {},
  classes: {},
  draggable: true,
  dialog_style: {},
};

CustomDialogBox.propTypes = {
  maxWidth: PropTypes.string,
  dialog_title: PropTypes.string,
  classes: PropTypes.any,
  draggable: PropTypes.bool,
  dialogBody: PropTypes.any.isRequired,
  dialogFooter: PropTypes.any.isRequired,
  dialog_style: PropTypes.any,
  Width: PropTypes.any,
};

export default CustomDialogBox;
